module.exports = __webpack_public_path__ + "img/photo-0001.6584b431.jpg";